<template>
  <!-- eslint-disable -->
  <div>
    <v-container>
      <!-- title -->
      <div class="d-flex align-center mx-6 mt-4 mb-6">
        <v-icon left size="30">mdi-account-group</v-icon>
        <h2 class="font-weight-regular">Suppliers</h2>
      </div>
      <!-- title -->

      <SuppliersTable :suppliers="suppliers" :loading="loadingSuppliers" />
    </v-container>
  </div>
</template>

<script>
import api from "../../../api";
import toasts from "../../../utils/toasts";

export default {
  data: () => ({
    loadingSuppliers: false,
    suppliers: undefined,
  }), // data

  mounted() {
    this.getSuppliersFromCurrentUser();
  }, // mounted

  methods: {
    async getSuppliersFromCurrentUser() {
      try {
        this.loadingSuppliers = true;
        this.suppliers = await api.superSuppliers.getFromCurrentUser();
        this.loadingSuppliers = false;
      } catch (error) {
        toasts.error(`Could not get suppliers -> ${error}`);
        this.loadingSuppliers = false;
      }
      this.loadingSuppliers = false;
    },
  }, // methods
};
</script>
